import { useState } from 'react'
import { apiEtapa2 } from '../api'
import Aviso from '../../components/Aviso'
import { moeda } from '../../components/format'
import { Campo, Cards, Gravado, Recibo, dataBR, listaValores } from '../componentes'

const INICIAL = {
  funcionario_id: 'F1',
  nome: '',
  salario_base: '',
  dependentes_irrf: 0,
  periodo_aquisitivo_inicio: '',
  periodo_aquisitivo_fim: '',
  faltas_injustificadas: 0,
  inicio_gozo: '',
  dias_gozo: '',
  abono_pecuniario: false,
  data_pagamento: '',
}

export default function Ferias({ empresaId }) {
  const [f, setF] = useState(INICIAL)
  const [variaveis, setVariaveis] = useState('')
  const [res, setRes] = useState(null)
  const [erro, setErro] = useState('')
  const [carregando, setCarregando] = useState(false)
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value })

  async function calcular(gravar) {
    setErro('')
    setCarregando(true)
    try {
      const entrada = {
        ...f,
        empresa_id: empresaId,
        dependentes_irrf: Number(f.dependentes_irrf) || 0,
        faltas_injustificadas: Number(f.faltas_injustificadas) || 0,
        dias_gozo: f.dias_gozo ? Number(f.dias_gozo) : null,
        data_pagamento: f.data_pagamento || null,
        variaveis_periodo_aquisitivo: listaValores(variaveis),
      }
      setRes(await apiEtapa2.calcularFerias(entrada, gravar))
    } catch (e) {
      setErro(e.message)
      setRes(null)
    } finally {
      setCarregando(false)
    }
  }

  const r = res?.resultado
  return (
    <section>
      <h2>Férias</h2>
      <div className="grade">
        <Campo rotulo="Matrícula"><input value={f.funcionario_id} onChange={set('funcionario_id')} /></Campo>
        <Campo rotulo="Nome"><input value={f.nome} onChange={set('nome')} /></Campo>
        <Campo rotulo="Salário base"><input type="number" step="0.01" value={f.salario_base} onChange={set('salario_base')} /></Campo>
        <Campo rotulo="Dependentes IRRF"><input type="number" min="0" value={f.dependentes_irrf} onChange={set('dependentes_irrf')} /></Campo>
        <Campo rotulo="Início do período aquisitivo"><input type="date" value={f.periodo_aquisitivo_inicio} onChange={set('periodo_aquisitivo_inicio')} /></Campo>
        <Campo rotulo="Fim do período aquisitivo"><input type="date" value={f.periodo_aquisitivo_fim} onChange={set('periodo_aquisitivo_fim')} /></Campo>
        <Campo rotulo="Faltas injustificadas"><input type="number" min="0" value={f.faltas_injustificadas} onChange={set('faltas_injustificadas')} /></Campo>
        <Campo rotulo="Início do gozo"><input type="date" value={f.inicio_gozo} onChange={set('inicio_gozo')} /></Campo>
        <Campo rotulo="Dias de gozo"><input type="number" min="5" value={f.dias_gozo} placeholder="todos os de direito" onChange={set('dias_gozo')} /></Campo>
        <Campo rotulo="Data de pagamento"><input type="date" value={f.data_pagamento} onChange={set('data_pagamento')} /></Campo>
        <label className="check"><input type="checkbox" checked={f.abono_pecuniario} onChange={set('abono_pecuniario')} />Abono pecuniário (vender 1/3)</label>
      </div>
      <Campo rotulo="Variáveis de cada mês do período aquisitivo (separadas por ponto e vírgula)">
        <input value={variaveis} onChange={(e) => setVariaveis(e.target.value)} placeholder="350,00; 420,50; 0; ..." />
      </Campo>
      <div className="acoes">
        <button disabled={carregando || !empresaId} onClick={() => calcular(false)}>Calcular</button>
        <button className="secundario" disabled={carregando || !empresaId} onClick={() => calcular(true)}>Calcular e gravar</button>
      </div>
      <Aviso>{erro}</Aviso>
      {r && (
        <>
          <Gravado registroId={res.registro_id} />
          <Cards
            itens={[
              ['Líquido', moeda(r.liquido), `Pagar até ${dataBR(r.data_limite_pagamento)}`],
              ['Gozo', `${r.dias_gozo} dias`, `${dataBR(r.inicio_gozo)} a ${dataBR(r.fim_gozo)} · retorno ${dataBR(r.data_retorno)}`],
              ['Abono', `${r.dias_abono} dias`, `${r.dias_direito} dias de direito`],
              ['Média de variáveis', moeda(r.media_variaveis)],
            ]}
          />
          <Recibo titulo={`Recibo de férias · pagamento em ${dataBR(r.data_pagamento)}`} resultado={r} />
        </>
      )}
    </section>
  )
}
